import { getDatabase, onValue, ref } from 'firebase/database';
import { getFirebaseBackend } from 'helpers/firebaseHelper';

const { parse } = require('json2csv');

const handleDownloadGuidelineCSV = async (accountId) => {
  try {
    const firebaseHelper = getFirebaseBackend();
    const db = getDatabase();
    const guidelinesRef = ref(db, `guidelines/${accountId}`);
    let allGuidelines = [];

    onValue(guidelinesRef, async (snapshot) => {
      const data = snapshot.val();

      const guidelinesWithIds = Object.entries(data ?? {}).flatMap(([key, value]) => {
        if (key !== 'metadata') {
          return {
            ...value,
            id: key,
          };
        } else {
          return [];
        }
      });

      allGuidelines = guidelinesWithIds;
    });

    await new Promise((resolve) => setTimeout(resolve, 1000));

    const guidelinesPromises = Object.values(allGuidelines).map(async (guideline) => {
      let assignedToNames = '';
      let responsibleToApprovalNames = '';

      if (guideline.assignedTo && guideline.assignedTo.length > 0) {
        const userPromises = guideline.assignedTo.map(
          async (userId) => await firebaseHelper.getUserName(userId),
        );
        const resolvedUserNames = await Promise.all(userPromises);
        assignedToNames = resolvedUserNames.join(',');
      }
      if (guideline.responsibleToApproval && guideline.responsibleToApproval.length > 0) {
        const userPromises = guideline.responsibleToApproval.map(
          async (userId) => await firebaseHelper.getUserName(userId),
        );
        const resolvedUserNames = await Promise.all(userPromises);
        responsibleToApprovalNames = resolvedUserNames.join(',');
      }

      return {
        id: guideline.id,
        column: guideline.column,
        assignedTo: assignedToNames,
        responsibleToApproval: responsibleToApprovalNames,
        primaryKeyword: guideline.primaryKeyword,
        secondaryKeywords: guideline.secondaryKeywords ? guideline.secondaryKeywords.join(',') : '',
        title: guideline.title || '',
        createdAt: guideline.createdAt
          ? new Date(guideline.createdAt).toISOString().substring(0, 10)
          : '',
        deliveryDate: guideline.deliveryDate
          ? new Date(guideline.deliveryDate).toISOString().substring(0, 10)
          : '',
        productionDateMonth: guideline.productionDate?.month || '',
        productionDateYear: guideline.productionDate?.year || '',
        searchVolume: guideline.searchVolume || '',
        content: guideline.content || '',
      };
    });

    const resolvedGuidelines = await Promise.all(guidelinesPromises);

    const csvOptions = {
      fields: [
        'id',
        'column',
        'assignedTo',
        'responsibleToApproval',
        'primaryKeyword',
        'secondaryKeywords',
        'title',
        'createdAt',
        'deliveryDate',
        'productionDateMonth',
        'productionDateYear',
        'searchVolume',
        'content',
      ],
      header: true,
    };

    const csvContent = parse(resolvedGuidelines, csvOptions);

    const blob = new Blob([csvContent], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);
    const accountName = await firebaseHelper.accountName(accountId);
    const dateNumber = new Date().toISOString().substring(0, 10);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${accountName}_${dateNumber}_guidelines_data.csv`;

    link.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading CSV', error);
  }
};

export { handleDownloadGuidelineCSV };
